import type { FunctionComponent, HTMLAttributes } from 'react';

import styles from './animatedIconRoot.module.css';

export interface AnimatedIconRootProps extends HTMLAttributes<HTMLDivElement> {}

export const AnimatedIconRoot: FunctionComponent<AnimatedIconRootProps> = ({ children, className, ...rest }) => {
  return (
    <div className={`${className} ${styles.animatedIconRoot}`} {...rest}>
      {children}
    </div>
  );
};
